<footer class="footer">
    <div class="container-fluid">
        <nav class="pull-left">
            <ul *ngIf="false">
                <li>
                    <a href="#">
                        Disabled
                    </a>
                </li>
            </ul>
        </nav>
        <div class="copyright pull-right">
            &copy; {{test | date: 'yyyy'}}, made with <i class="fa fa-heart heart"></i> by Noteefy
        </div>
    </div>
</footer>
